<template>
  <AppModal @click="() => emit('close')">
    <div class="p-4 leading-6">
      <h2 class="text-base md:text-lg font-semibold">
        {{ $t('common.share') }}
      </h2>
      <span class="text-sm md:text-base mb-4">{{ title }}</span>
      <div
        class="a2a_kit a2a_kit_size_32 a2a_default_style flex gap-4 justify-center mt-4"
        :data-a2a-url="url"
        :data-a2a-title="title"
      >
        <a
          class="a2a_button_facebook hover:opacity-80 transition-opacity"
          title="Share on Facebook"
        ></a>
        <a
          class="a2a_button_whatsapp hover:opacity-80 transition-opacity"
          title="Share on WhatsApp"
        ></a>
        <a
          class="a2a_button_threads hover:opacity-80 transition-opacity"
          title="Share on Threads"
        ></a>
        <a
          class="a2a_button_x hover:opacity-80 transition-opacity"
          title="Share on X"
        ></a>
        <a
          class="a2a_button_email hover:opacity-80 transition-opacity"
          title="Share via Email"
        ></a>
      </div>
    </div>
  </AppModal>
</template>

<script setup lang="ts">
interface Props {
  url: string;
  title: string;
}

const AppModal = defineAsyncComponent(
  () => import('@/async-components/App/Modal.vue')
);

withDefaults(defineProps<Props>(), {
  url: window?.location?.href || '',
  title: 'PFS Realty'
});

const emit = defineEmits(['close']);

declare global {
  interface Window {
    a2a_config: {
      locale?: string;
    };
    a2a: {
      init_all: () => void;
    };
  }
}

const initializeA2A = async () => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line camelcase, prefer-const
    let a2a_config = window.a2a_config || {};

    // eslint-disable-next-line camelcase
    a2a_config.locale = 'es';

    const existingScript = document.querySelector('script[src*="addtoany"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.defer = true;
    script.src = 'https://static.addtoany.com/menu/page.js';
    document.head.appendChild(script);

    await nextTick();
    if (window.a2a) {
      window.a2a.init_all();
    }
  }
};

onMounted(() => {
  initializeA2A();
});
</script>

<style scoped>
/* AddToAny will inject its own styles */
</style>
